import React, { useEffect, useState, useRef } from "react";
import { Box, Modal, Button, Checkbox, FormControlLabel } from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import {
  DiagnosisUpdate,
  diagnosisId,
} from "../../../services/nursing/NursingCarePlanServices";
import { CloseModalIcon } from "../../../../common/components/assets/commonassets/CommonAssets";
import InputField from "../../../../common/components/FormFields/InputField";
import { ModalStyle } from "../../../../common/components/ModalStyle";

export default function DiagnosisEditDialog({
  open,
  onClose,
  data,
  setSnack,
  onUpdateSuccess,
}) {
  const [confirmUpdateOpen, setConfirmUpdateOpen] = useState(false);
  const initialDataRef = useRef(null);
  const [isLoaded, setIsLoaded] = useState(false);

  const defaultFormValues = {
    description: "",
    active: false,
  };

  const { control, watch, setValue, reset } = useForm({
    defaultValues: defaultFormValues,
  });

  const handleUpdate = async () => {
    try {
      const values = watch();
      const payload = {
        id: data?.id ?? data?.Id,
        description: values.description || "",
        active: values.active ?? false,
      };
      console.log("UPDATE PAYLOAD 👉", payload);
      const res = await DiagnosisUpdate(payload);
      setSnack({
        open: true,
        message: res?.data?.message || "NursingDiagnosis updated successfully",
        severity: "success",
      });
      onUpdateSuccess({
        id: payload.id,
        description: payload.description,
        active: payload.active,
      });
      setConfirmUpdateOpen(false);
      onClose();
    } catch (error) {
      console.error("Update failed", error);

      setSnack({
        open: true,
        message: error?.response?.data?.message || "Update failed",
        severity: "error",
      });
    }
  };

  const resetAllData = () => {
    reset(defaultFormValues);
  };

  useEffect(() => {
    const fetchDiagnosis = async () => {
      if (!data?.id && !data?.Id) return;
      try {
        const id = data?.id ?? data?.Id;
        const response = await diagnosisId(id);
        const editData = response?.data?.result?.[0];
        const formattedData = {
          description: editData?.Description || "",
          active: editData?.Active ?? false,
        };
        initialDataRef.current = formattedData;
        reset(formattedData);
        setIsLoaded(true);
      } catch (error) {
        console.error("Edit fetch error", error);
      }
    };

    if (open && !isLoaded) {
      fetchDiagnosis();
    }
  }, [open, data]);

  return (
    <>
      <Modal open={open} onClose={onClose}>
        <Box sx={ModalStyle} className="w-[500px] space-y-4">
          <div className="flex justify-between">
            <label className="font-semibold text-lg">Diagnosis Details</label>
            <CloseModalIcon onClick={onClose} />
          </div>

          <Box
            sx={{
              display: "flex",
              alignItems: "flex-end",
              gap: 2,
              width: "100%",
            }}
          >
            <Box sx={{ flex: 1 }}>
              <InputField
                control={control}
                name="description"
                label="Description"
                placeholder="Description"
              />
            </Box>

            <Controller
              name="active"
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={field.value}
                      onChange={(e) => field.onChange(e.target.checked)}
                      sx={{
                        color: "#1e3a8a",
                        "&.Mui-checked": {
                          color: "#1e3a8a",
                        },
                      }}
                    />
                  }
                  label="Active"
                />
              )}
            />
          </Box>

          <div className="flex items-center justify-end gap-2  mt-6">
            <button
              type="button"
              onClick={resetAllData}
              className="h-[36px] px-4 rounded border border-red-500 text-red-500 text-sm font-semibold hover:bg-red-50"
            >
              Reset
            </button>

            <button
              type="button"
              onClick={() => setConfirmUpdateOpen(true)}
              className="h-[36px] px-4 rounded text-white bg-blue-900 hover:bg-blue-800 text-sm font-semibold"
            >
              Update
            </button>
          </div>
        </Box>
      </Modal>

      <Modal open={confirmUpdateOpen}>
        <Box
          sx={{
            width: 400,
            bgcolor: "background.paper",
            p: 3,
            borderRadius: 2,
            mx: "auto",
            mt: "20%",
          }}
        >
          <h3 className="font-semibold mb-3">Confirm Update</h3>

          <p className="mb-4">Are you sure you want to update?</p>

          <div className="flex justify-end gap-2">
            <Button color="success" onClick={() => setConfirmUpdateOpen(false)}>
              Cancel
            </Button>

            <Button variant="contained" color="success" onClick={handleUpdate}>
              Confirm
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
}
